export const snackbar = (type?: string) => {
  return {
    background:
      type === 'error' || type === 'error_inline' || type === undefined
        ? '#FFEFEE'
        : type === 'info'
        ? '#E5F0FA'
        : type === 'warning'
        ? '#FEF5E8'
        : type === 'success' && '#E9F7F2',
    p: '12px',

    '& .MuiSnackbarContent-message': {
      p: '0',
    },

    '& .MuiSnackbarContent-message > p': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color:
        type === 'error' || type === 'error_inline' || type === undefined
          ? '#FF5F57'
          : type === 'info'
          ? '#0072CE'
          : type === 'warning'
          ? '#FF9100'
          : type === 'success' && '#24B07E',
      p: 0,
    },
  };
};
